"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.ContextConsumer = exports.ContextProvider = exports.Context = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _UserContext = require("./UserContext/UserContext");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

var INITIAL_SEARCH_CONTEXT = {
  searchActive: false,
  searchPhrase: '',
  searchCategory: 'All'
};

var INITIAL_CONTEXT = _objectSpread(_objectSpread({
  activeKey: '',
  chromelessFloating: false,
  expanded: false,
  banner: false,
  hasLinks: true
}, INITIAL_SEARCH_CONTEXT), {}, {
  searchResultsRef: /*#__PURE__*/_react["default"].createRef()
});

var noop = function noop() {// empty placeholder function for context init
};

var defaultValue = _objectSpread(_objectSpread({}, INITIAL_CONTEXT), {}, {
  resetSearch: noop,
  setChromeless: noop,
  setChromelessFloating: noop,
  setExpanded: noop,
  setHasOpenMenu: noop,
  setSearchActive: noop,
  setSearchCategory: noop,
  setSearchPhrase: noop,
  setSearchResultsRef: noop
});

var Context = _react["default"].createContext(defaultValue);

exports.Context = Context;
Context.displayName = 'CommonChromeContext';

var CommonChromeContextProvider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(CommonChromeContextProvider, _React$Component);

  var _super = _createSuper(CommonChromeContextProvider);

  function CommonChromeContextProvider(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CommonChromeContextProvider);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "resetSearch", function () {
      _this.setState(INITIAL_SEARCH_CONTEXT);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setterFor", function (propName) {
      return function (propValue) {
        return _this.setState((0, _defineProperty3["default"])({}, propName, propValue));
      };
    });
    _this.state = INITIAL_CONTEXT;
    return _this;
  }

  (0, _createClass2["default"])(CommonChromeContextProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react["default"].createElement(_UserContext.UserContext.Consumer, null, function (userContext) {
        return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
          value: {
            activeKey: _this2.props.activeKey,
            chromeless: _this2.props.chromeless,
            chromelessFloating: _this2.state.chromelessFloating,
            expanded: userContext.navigation.expanded,
            banner: _this2.props.banner,
            hasOpenMenu: _this2.state.hasOpenMenu,
            links: _this2.props.links,
            hasLinks: _this2.props.hasLinks,
            LinkWrapper: _this2.props.LinkWrapper,
            searchActive: _this2.state.searchActive,
            searchCategory: _this2.state.searchCategory,
            searchPhrase: _this2.state.searchPhrase,
            searchResultsRef: _this2.state.searchResultsRef,
            resetSearch: _this2.resetSearch,
            setChromelessFloating: _this2.setterFor('chromelessFloating'),
            setExpanded: userContext.setSidebarExpanded,
            setHasOpenMenu: _this2.setterFor('hasOpenMenu'),
            setSearchActive: _this2.setterFor('searchActive'),
            setSearchCategory: _this2.setterFor('searchCategory'),
            setSearchPhrase: _this2.setterFor('searchPhrase'),
            setSearchResultsRef: _this2.setterFor('searchResultsRef')
          }
        }, _this2.props.children);
      });
    }
  }]);
  return CommonChromeContextProvider;
}(_react["default"].Component);

var ContextProvider = CommonChromeContextProvider;
exports.ContextProvider = ContextProvider;
var ContextConsumer = Context.Consumer;
exports.ContextConsumer = ContextConsumer;